import { LayoutState, LayoutMode } from './types';

export const layoutInitialState: LayoutState = {
  isNotPremiumModalOpen: false,
  layoutMode: LayoutMode.DEFAULT,
};
